<template>
    <div>
        <div class="main-button-bar">
            <el-row class="search-row">
                <el-select v-model="params.shopId" clearable placeholder="所属店铺" class="search-item">
                    <el-option
                        v-for="item in shops"
                        :key="item.id"
                        :label="item.shortName"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <el-select
                    multiple
                    collapse-tags
                    v-model="params.statusArr"
                    clearable
                    placeholder="订单状态"
                    class="search-item"
                >
                    <el-option v-for="item in status" :key="item" :label="item" :value="item"></el-option>
                </el-select>

                <el-select
                    multiple
                    collapse-tags
                    v-model="params.prdStatusArr"
                    clearable
                    placeholder="生产状态"
                    class="search-item"
                >
                    <el-option v-for="item in prdStatus" :key="item" :label="item" :value="item"></el-option>
                </el-select>

                <sn-user-search-input
                    title="销售员名称"
                    class="search-item"
                    @change="
              (a) => {
                params.seller = a;
              }
            "
                ></sn-user-search-input>

                <el-select
                    v-model="params.isSample"
                    clearable
                    placeholder="样板单"
                    class="search-item"
                >
                    <el-option v-for="item in isSample" :key="item.key" :label="item.value" :value="item.key"></el-option>
                </el-select>

                <el-input v-model="params.buyerStr" placeholder="客户名称" class="search-item"></el-input>
            </el-row>
            <el-row class="search-row">
                <el-date-picker
                    type="date"
                    placeholder="订单统计时间（开始）"
                    v-model="params.createDateStart"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>

                <el-date-picker
                    type="date"
                    placeholder="订单统计时间（截止）"
                    v-model="params.createDateEnd"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>

                <el-date-picker
                    type="date"
                    placeholder="约定发货时间（开始）"
                    v-model="params.agreedShipmentDateStart"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>

                <el-date-picker
                    type="date"
                    placeholder="约定发货时间（截止）"
                    v-model="params.agreedShipmentDateEnd"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>

                <el-input v-model="params.id" placeholder="订单号" class="search-item"></el-input>
                <el-button type="primary" size="small" @click="page(1)">搜索</el-button>
                <alibaba-order-total :params="params"></alibaba-order-total>
            </el-row>
        </div>

        <el-table
            :data="records"
            stripe
            style="width: 100%"
            :height="this.$tools.mainHeight() - 135"
            class="alibaba-order-table"
        >
            <el-table-column prop="shopName" label="所属店铺" width="100"></el-table-column>
            <el-table-column prop="sellerName" label="销售员" width="100"></el-table-column>
            <el-table-column prop="buyerName" label="客户名称" width="200"></el-table-column>
            <el-table-column prop="id" label="订单号" width="220">
                <template slot-scope="order">
                    <span v-if="order.row.confirmTags == 'cancel'" style="color:#C0C4CC">{{order.row.id}}</span>
                    <span v-else-if="order.row.confirmTags" style="color:#67C23A">{{order.row.id}}</span>
                    <span v-else>{{order.row.id}}</span>

                    <span v-if="order.row.confirmTags">
                        <el-tag type="success" v-if="order.row.confirmTags == 'sample_order' && order.row.tags.indexOf('sample_order') != -1">样</el-tag>
                        <el-tag type="danger" v-else-if="order.row.confirmTags == 'sample_order' ">样</el-tag>

                        <el-tag type="success" v-if="order.row.confirmTags == 'isShippingFee' && order.row.isShippingFee == 'Y'">运</el-tag>
                        <el-tag type="danger" v-else-if="order.row.confirmTags == 'isShippingFee'">运</el-tag>
                    </span>
                    <span v-else>
                        <el-tag type="success" v-if="order.row.tags.indexOf('sample_order') != -1">样</el-tag>
                        <el-tag type="success" v-else-if="order.row.isShippingFee == 'Y'">运</el-tag>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="订单状态" width="200"></el-table-column>
            <el-table-column prop="productStatus" label="生产状态" width="100"></el-table-column>

            <el-table-column prop="totalAmount" label="订单金额($)" width="100">
                <template slot-scope="order">{{ $tools.parsecost(order.row.totalAmount, true)}}</template>
            </el-table-column>

            <el-table-column prop="shippingFeeAmount" label="运费($)" width="100">
                <template slot-scope="order">{{ $tools.parsecost(order.row.shippingFeeAmount, true)}}</template>
            </el-table-column>

            <el-table-column prop="advanceAmount" label="预付款($)" width="100">
                <template slot-scope="order">{{ $tools.parsecost(order.row.advanceAmount, true)}}</template>
            </el-table-column>
            
            <el-table-column prop="createDate" label="下单时间" width="160">
                <template slot-scope="order">{{ $tools.timestampToTime(order.row.createDate)}}</template>
            </el-table-column>

            <el-table-column prop="agreedShipmentDate" label="约定发货时间" width="160">
                <template
                    slot-scope="order"
                >{{ $tools.timestampToTime(order.row.agreedShipmentDate)}}</template>
            </el-table-column>

            <el-table-column label="操作" width="180" fixed="right">
                <template slot-scope="order">
                    <el-button v-if="!order.row.confirmTags" type="text" size="small" v-on:click="confirmTags(order.row.id, order.row.tags.indexOf('sample_order') != -1, order.row.isShippingFee == 'Y')">确认订单</el-button>
                    <el-button type="text" size="small" v-on:click="info(order.row.id, order.row.buyerName)">详情</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            small
            layout="total, prev, pager, next"
            :total="params.total"
            @current-change="page"
            :current-page.sync="params.current"
        ></el-pagination>
        <alibaba-order-info :title="orderTitle" :show.sync="showInfo" :orderId="orderId" :isRoot="false"></alibaba-order-info>
        <el-dialog title="订单确认" :visible.sync="showConfirm" width="500px">
            <el-form ref="confirmForm">
                <el-form-item label="编号">
                    {{ orderId }}
                </el-form-item>

                <el-form-item label="类型">
                      <el-radio-group v-model="confirmType">
                        <el-radio label="cancel">无效订单</el-radio>
                        <el-radio label="formal">大货订单</el-radio>
                        <el-radio label="sample_order">样板单</el-radio>
                        <el-radio label="isShippingFee">运费单</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" class="op-button" @click="doConfirm()" >确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import SnUserSearchInput from "../components/SnUserSearchInput.vue";
import AlibabaOrderInfo from './Alibaba-order-info.vue';
import AlibabaOrderTotal from "./Alibaba-order-total.vue";
export default {
    components: { SnUserSearchInput, AlibabaOrderInfo, AlibabaOrderTotal },
    data() {
        return {
            shops: [],
            status: [
                "订单关闭",
                "订单完成",
                "待买家付款",
                "待卖家接单",
                "待卖家确认订单",
                "待买家支付预付款",
                "待买家支付尾款",
                "待买家确认已修改的合同",
                "待卖家确认尾款金额",
                "待卖家发货",
                "待买家确认收货",
                "发货中",
            ],
            prdStatus: ["打样中", "生产产前样", "生产大货", "已出货"],
             isSample: [{key: 'Y', value: '是'}, {key: 'N', value: '否'}],
            records: null,
            params: {
                shopId: null,
                seller: null,
            },
            showInfo: false,
            orderId: null,
            orderTitle: null,
            showConfirm: false,
            confirmType: null,
        };
    },
    mounted() {
        this.getShops();
        this.page(1);
    },
    methods: {
        getShops() {
            let _this = this;

            _this.$http.post(
                ["alibaba/shop/all"],
                [
                    function (data) {
                        _this.shops = data;
                    },
                ],
                ".alibaba-buyer-table"
            );
        },
        page(current) {
            let _this = this;

            if (current) {
                _this.params.current = current;
            }

            _this.params.status = _this.params.statusArr.join(",");
            _this.params.productStatus = _this.params.prdStatusArr.join(",");

            _this.$http.post(
                ["alibaba/order/mypage", _this.params],
                [
                    function (data) {
                        _this.params.total = data.total;
                        _this.records = data.records;
                    },
                ],
                ".alibaba-order-table"
            );
        },
        info(id, title) {
            this.orderId = id;
            this.orderTitle = "客户【"  + title + "】的【" + id + "】订单";
            this.showInfo = true;
        },
        confirmTags(id, isSample, isShippingFee) {
            this.orderId = id;
            this.confirmType = isSample ? 'sample_order': (isShippingFee ? 'isShippingFee': 'formal');
            this.showConfirm = true;
        },
        doConfirm()  {
            let _this = this;

            _this.$http.post(
                ["alibaba/order/confirmTags", {id: _this.orderId, confirmTags: _this.confirmType}],
                [
                    function (data) {
                        _this.showConfirm = false;
                        _this.page();
                    },
                ],
                ".alibaba-order-table"
            );
        }
    },
};
</script>

<style lang="scss" scoped>
</style>